import type { PlayerInterface } from "@foundation-player/api";
import { Plugin } from "./media_plugin.js";

/**
 * For more information on how to mimic full-screen mode on iPhones,
 * see the relevant Foundation UI documentation:
 *
 * @see https://docs.player.foundation/v2/integration/foundation-ui/overview/#mimic-fullscreen-on-an-iphone
 */
export class PluginFullscreen extends Plugin {
  public isEnabled(): boolean {
    return true;
  }

  public addFoundationEventListener(
    foundationPlayer: PlayerInterface,
    element: HTMLElement,
  ): void {
    const playerWrapper: HTMLElement | null =
      element.closest(".player-wrapper");

    if (!playerWrapper) {
      return;
    }

    foundationPlayer.addEventListener("ui:EnterFullscreenRequest", () => {
      playerWrapper.classList.add("is-fullscreen");
      document.body.classList.add("u-has-fullscreen-video");
    });

    foundationPlayer.addEventListener("ui:ExitFullscreenRequest", () => {
      playerWrapper.classList.remove("is-fullscreen");
      document.body.classList.remove("u-has-fullscreen-video");
    });
  }
}
